import { createApp } from 'vue'
import router from './router'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/500.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

// Import Bootstrap 5 CSS i JS (bundle zawiera Popper.js)
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Import Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css'
import App from './App.vue'

const app = createApp(App)

// Podpięcie Vue Router
app.use(router)

app.mount('#app')